// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3mGzu","choiceBoxes":"toolbarselects_choiceBoxes__3jbJL","simpleField":"toolbarselects_simpleField__2AOET"};